/**
 * A HOC wrapping Material UIs Table Component. Used to unify the styles across
 * all of our tables.
 */
import { isEmpty, omit } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'tss-react/mui';
import { Table } from '@mui/material';

const styles = (theme, props) => {
  const { fixed = true } = props;
  if (isEmpty(theme)) return {};

  return {
    root: {
      minWidth: '700px',
      tableLayout: fixed ? 'fixed' : undefined,
      [theme.breakpoints.up('lg')]: {
        minWidth: '960px',
      },
      [theme.breakpoints.up('xl')]: {
        minWidth: '1200px',
      },
      '& th:first-of-type': {
        borderRadius: '4px 0 0 4px',
      },
      '& th:last-child': {
        borderRadius: '0 4px 4px 0',
      },
    },
  };
};

const ReusableTable = withStyles((props) => {
  const { classes } = props;
  return (
    <Table
      padding="normal"
      className={classes.root}
      {...omit(props, 'fixed')}
    />
  );
}, styles);

ReusableTable.propTypes = {
  fixed: PropTypes.bool,
};

export default ReusableTable;
